import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-user-service-schema'
import config from './req.config'

export type { paths as UserPaths }

export const userServiceReq = createFetchClient<paths>({
  ...config,
})

export const userServiceQuery = createClient<paths>(userServiceReq)
